import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
// import { Toast } from 'react-bootstrap';
import AlumniService from '../../../services/AlumniService';
import { VideoModal } from './VideoModal';
import { Context } from '../../..';
import { useNavigate } from 'react-router-dom';
import { ModalPopover } from './modal-popover';
// import { MyDocsModal } from './MyDocsModal';
// import { municipality } from '../../types/municipalityTypes';
// import { years } from '../../types/yearsTypes';

const Video: FC<any> = observer(({ video, setVideoModal, setVideoData, setVideoDate, setDelVideoId, setDelVideoModal }) => {

    const date = video['create_date'].split('T');
    const formattedDate = date[0].split('-');

    return (
        <div className='row'>
            <div className="col">
                <div className={"card mt-2 video" + (video['moderated'] ? " border-success bg-success" : " border-warning bg-warning")} onClick={() => {
                    setVideoModal(true);
                    setVideoData(video);
                    setVideoDate(`${formattedDate[2]}.${formattedDate[1]}.${formattedDate[0]}`);
                }}>
                    <div className="card-header video-header">
                        <h5>
                            {video['alumni_fio']}, {video['issue_year']}, {video['school']}, {video['municipality']}
                        </h5>
                    </div>
                </div>
            </div>

            <div className="col-md-1">
                <i className='icon trash' onClick={() => {
                    setDelVideoId(video['id']);
                    setDelVideoModal(true);
                }} />
            </div>
        </div>

    )
});

interface VideoProps {
    fix: boolean;
    setFix: (value: boolean) => void;
}

const Videos: FC<VideoProps> = observer(({ fix, setFix }) => {
    const { store } = useContext(Context);
    const [videos, setVideos] = useState<[]>([]);
    const [videoModal, setVideoModal] = useState<boolean>(false);
    const [videoData, setVideoData] = useState<any>({});
    const [videoDate, setVideoDate] = useState<string>('');
    const [delVideoId, setDelVideoId] = useState<number>(-1);
    const [delVideoModal, setDelVideoModal] = useState<boolean>(false);

    const getVideos = async () => {
        const videos = await AlumniService.getAllVideos();
        setVideos(videos.data.results);
    };

    useEffect(() => {
        getVideos();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix])

    const getItems = () => videos.sort((a, b) => b['id'] - a['id']).map((video, i) => {
        return <Video key={i} {...{ video, setVideoModal, setVideoData, setVideoDate, setDelVideoId, setDelVideoModal }} />
    });

    const deleteVideo = async () => {
        await AlumniService.removeVideo(delVideoId);
        setFix(true);
        setDelVideoModal(false);
        setDelVideoId(-1);
    };


    return (
        <div>
            {getItems()}
            <VideoModal toggle={videoModal} setToggle={setVideoModal} data={videoData} date={videoDate} setFix={setFix} />
            <ModalPopover
                toggle={delVideoModal}
                setToggle={setDelVideoModal}
                title={store.lang === 'ba' ? 'Видеоны алып ташлау' : store.lang === 'ru' ? 'Удаление видео' : 'Deleting an video'}
                modalContent={<Trans>Do you want to delete an video?</Trans>}
                clickedButtonOne={() => deleteVideo()}
                clickedButtonTwo={() => { setDelVideoModal(false); setDelVideoId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    )
});

interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const VideoModerateModal: FC<ModalProps> = props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context);
    const navigate = useNavigate();
    // const [videoData, setVideoData] = useState({ "author": "", "header": "", "alumni_fio": "", "school": "", "issue_year": 2024, "municipality": store.specInfo?.municipality, "video_link": "" });
    const [fix, setFix] = useState<boolean>(false);
    // const [myDocsModal, setMyDocsModal] = useState<boolean>(false);
    // const [showToast, setShowToast] = useState(false);
    // const [toastInfo, setToastInfo] = useState('');

    const onRequestClose = () => {
        setToggle(false);
    };

    // const onChange = (e: React.ChangeEvent<any>) => {
    //     setVideoData({ ...videoData, [e.target.id]: e.target.value });
    // };

    // const saveVideo = async () => {
    //     await AlumniService.createVideo(videoData);
    //     setFix(true);
    //     setVideoData({ "author": "", "header": "", "alumni_fio": "", "school": "", "issue_year": 2024, "municipality": store.specInfo?.municipality, "video_link": "" });
    //     setToastInfo(store.lang === 'ba' ? 'Ваҡиға өҫтәлде' : store.lang === 'ru' ? 'Событие создано' : 'Video has been created');
    //     setShowToast(true);
    // };

    useEffect(() => {
        if (!store.user.is_staff) {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user.is_staff])


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Configure the video page</Trans></div>
            </div>
            <form className="Modal__Body">
                <div className="row form-group">
                    <div className="col">
                        <Videos {...{ fix, setFix }} />
                    </div>
                </div>
            </form>
            {/* <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                <Toast.Header className='bg-success m-0 text-light'>
                    <strong className="me-auto"><Trans>Information</Trans></strong>
                </Toast.Header>
                <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
            </Toast> */}
            {/* <MyDocsModal toggle={myDocsModal} setToggle={setMyDocsModal} /> */}
        </Modal>
    );
};